/* eslint-disable no-unused-vars */

import React, { useState, useEffect } from "react";
import {
  Grid,
  TextField,
  Typography,
  MenuItem,
  Button,
  Modal,
  InputLabel,
  FormControl,
  Select,
} from "@mui/material";
import data from "../../Component/dropDown";
import { API } from "../backend";
import { useDispatch, useSelector } from "react-redux";
import { setTransactionDetails } from "../../store/reducers/transactionDetails";
import InputField from "../../Component/forms/input/TextInput/InputField";
import { examPrices } from "../../partials/examboardprices/examprices";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import FormButton from "../../Component/ui/button/FormButton";
import axios from "axios";
import { closeModal } from "../../store/reducers/modal";
import Spinner from "../../Component/ui/Spinner";
import InvoiceButtonWithConfirmation from "../../Component/InvoiceButtonWithConfirmation";

const IndividualTrade = ({
  examName,
  examType = "PUBLIC SERVICE EXAAM FORM",
  payerID,
}) => {
  const { Lga } = data;
  const [invoiceLoading, setInvoiceLoading] = useState(false);
  const dispatch = useDispatch();
  const [showTimeoutModal, setShowTimeoutModal] = useState(false);
  const [modelPrice, setModelPrice] = useState(
    examPrices.modelCollegeExamFeePerCandidiate
  );
  const token = useSelector((state) => state.user.data.token);
  const [pubicServiceData, setPublicServiceData] = useState([]);
  const navigate = useNavigate();
  const [lga, setLga] = useState(Lga);
  const user = useSelector((state) => state.user.data.details);
  console.log(lga);

const [formData, setFormData] = useState({
  // Personal Details
  firstName: "",
  middleName: "",
  lastName: "",
  dateOfBirth: "",
  examNumber: "",
  phoneNumber: "",
  stateOfOrigin: "",
  localGovernment: "",
  address: "",
  nin: "",
  lassra: "",

  // Trade Test Information
  typeOfTradeTest: "",
  paymentReceiptNumber: "",
  yearOfExamination: "",

  // Professional Information (For Civil Servants Only)
  qualification: "",
  qualificationDate: "",
  firstAppointmentDate: "",
  presentAppointmentDate: "",
  designation: "",
  oracleNumber: "",
  mda: "",

  // Examination Information
  examinationCenter: "",
  examinationDate: ""
});

 const handlInputChange = (e) => {
  const { name, value, type } = e.target;
  
  // For select fields (like LGA), don't trim the value
  const shouldTrim = type !== 'select-one';
  
  setFormData({
    ...formData,
    [name]: shouldTrim ? value?.trim() : value
  });
};

  const priceInt = modelPrice.replace(/\D/g, "");
  const totalFee = priceInt;
  const totalAmount = parseInt(totalFee);

  const saveGeneratedBill = async (body) => {
    try {
      const res = await axios.post(`${API}/bills/create`, body, {
        headers: { Authorization: `Bearer ${token}` },
      });
      // console.log(res);
    } catch (error) {}
  };

  const getModelCollegeBillable = async () => {
    const examBillable_url = `${API}/cbs/public_billables`;

    try {
      const res = await axios.get(examBillable_url, {
        headers: { Authorization: `Bearer ${token}` },
      });
      // console.log(res);
      setPublicServiceData(res?.data?.data);
      // console.log(modelCollegeData);
    } catch (error) {
      // console.log(error);
    }
  };

  useEffect(() => {
    getModelCollegeBillable();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const updateIndividualDetails = async () => {
    const updateUrl = `${API}/individual/02`;
    // const updateUrl = `${API}/individual/01`;
    // const updateUrl = examName === "Public Service" ? publicUpdate : modelUpdate;

    try {
      const res = await axios.patch(
        updateUrl,
        { payerID },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      // console.log(res);
    } catch (error) {
      // console.log(error);
    }
  };

  const generateBillNo = async () => {
    // Start the timeout
    let timeoutId = setTimeout(() => {
      setShowTimeoutModal(true);
    }, 120000); // 2 minutes in milliseconds
    const body = {
      payer_id: payerID,
      customer_name: `${formData.firstName} ${formData.lastName}`,
      selected_quantities: [1],
      selected_items: [pubicServiceData?.[1]?.PRODUCTS_ID],
      selected_tariffs: [parseInt(totalFee)],
      assessmentCode: "02",
    };

    try {
      const res = await axios.post(`${API}/cbs/create_invoice`, body, {
        headers: { Authorization: `Bearer ${token}` },
      });
      // If the request completes successfully, clear the timeout
      clearTimeout(timeoutId);
      // console.log(res)
      if (res?.status === 200) {
        updateIndividualDetails();
        // console.log(res?.status);
        // console.log(res?.data);
        // console.log(res?.data?.data?.responseData);

        const billdata = {
          // schoolId: '',
          billNumber: res?.data?.data?.bill_number,
          payerId: payerID,
          amountGenerated: totalFee,
          customerName: `${formData.firstName} ${formData.lastName}`,
          quantity: 1,
          assessmentCode: "02",
          payerInfos: [
            {
              surname: `${formData.lastName}`,
              firstName: `${formData.firstName}`,
              middleName: `${formData.middleName}`,
              locationIdOrExamId: lga,
            },
          ],
        };
        const bill = saveGeneratedBill(billdata);
        // console.log(bill)

        const userTransactionDetails = {
          payerName: `${formData.lastName} ${formData.firstName}`,
          productQuantity: 1,
          // price: amount,
          price: totalFee,
          // schoolName: "",
          // unitPrice: priceInt,
          //   email: user?.email,
          email: formData.email,
          examType,
          paymentExamType: examName,
          fullDesc: "Public Service Examnimation",
          billNumber: res?.data?.data?.bill_number,
          payerId: payerID,
          address: user?.address,
          // schoolName: user?.schoolName,
          priceWithCharge: totalAmount,
        };
        dispatch(setTransactionDetails(userTransactionDetails));
        dispatch(closeModal({ content: <></> }));

        // console.log(userTransactionDetails);
        // console.log(details);

        // dispatch(setTransactionDetails(details.billNumber = res?.data?.data?.responseData ));
        // console.log(details)
        navigate("/invoice");
      }
      // console.log(res);
    } catch (error) {
       if (axios.isAxiosError(error)) {
          const backendMessage = error.response?.data?.message || "Something went wrong";
          toast.error(backendMessage);
        } else {
           toast.error("Unable to generate invoice, please try again later.");
        }
    }
  };

  const handleInvoiceClick = async (e) => {
    setInvoiceLoading(true);
    try {
      // e.preventDefault();
      if (!lga) {
        throw new Error("Local Government Area is Required.");
      } else if (!formData.firstName || !formData.lastName) {
        throw new Error("First Name and Last Name are Required");
      }
      if (
        formData.firstName.trim().length < 3 ||
        formData.lastName.trim().length < 3
      ) {
        throw new Error(
          "First Name and Last Name are required with a minimum of 3 characters."
        );
      }

      const alphaRegex = /^[A-Za-z]+(-[A-Za-z]+)*$/;

      const regex = /[0-9~`!@#$%^&*()_+=\-[\]\\';,/{}|\\":<>?]/;
      if (!alphaRegex.test(formData.firstName)) {
        throw new Error("First name should contain only alphabetical letters.");
      } else if (!alphaRegex.test(formData.lastName)) {
        throw new Error("Last name should contain only alphabetical letters.");
      }

      await generateBillNo();
      // console.log(transactionDetails)
      // console.log(examName)
    } catch (error) {
      // console.log(error);
      toast.error(error.message);
    } finally {
      setInvoiceLoading(false);
    }
  };

  return (
    <div
      style={{
        padding: "16px",
        maxHeight: "calc(100vh - 160px)",
        overflowY: "auto",
      }}
    >
      {showTimeoutModal && (
        <Modal
          show={showTimeoutModal}
          onHide={() => setShowTimeoutModal(false)}
        >
          <Modal.Header closeButton>
            <Modal.Title>Server Delay</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            The bill generation is taking longer than expected. This may be due
            to a delay from our third-party server. Please wait a moment and try
            again later.
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={() => setShowTimeoutModal(false)}
            >
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      )}
      <div
        style={{
          // display: "flex",
          // alignItems: "center",
          // gap: "1.5rem",
          padding: "16px",
        }}
      >
       <div>
  {/* Personal Details Section */}
  <Typography variant="h6" gutterBottom style={{ marginTop: '20px', font:"bolder" }}>
    Personal Details
  </Typography>
  
  {/* Name Row */}
  <Grid container spacing={2}>
    <Grid item xs={12} sm={4} md={4}>
      <InputField
        name="firstName"
        label="First Name"
        value={formData.firstName}
        onChange={handlInputChange}
        placeholder="Enter First Name"
        type="text"
        style={{ width: "100%" }}
      />
    </Grid>
    <Grid item xs={12} sm={4} md={4}>
      <InputField
        name="middleName"
        label="Middle Name"
        value={formData.middleName}
        onChange={handlInputChange}
        placeholder="Enter Middle Name"
        type="text"
        style={{ width: "100%" }}
      />
    </Grid>
    <Grid item xs={12} sm={4} md={4}>
      <InputField
        name="lastName"
        label="Surname"
        type="text"
        placeholder="Enter Surname"
        value={formData.lastName}
        onChange={handlInputChange}
        style={{ width: "100%" }}
      />
    </Grid>
  </Grid>

  {/* Date of Birth and Exam Number Row */}
  <Grid container spacing={2} style={{ marginTop: '10px' }}>
    <Grid item xs={12} sm={6} md={6}>
      <InputField
        name="dateOfBirth"
        label="Date of Birth"
        type="date"
        value={formData.dateOfBirth}
        onChange={handlInputChange}
        InputLabelProps={{ shrink: true }}
        style={{ width: "100%" }}
      />
    </Grid>
    <Grid item xs={12} sm={6} md={6}>
      <InputField
        name="examNumber"
        label="Exam Number"
        value={formData.examNumber}
        onChange={handlInputChange}
        placeholder="Enter Exam Number"
        type="text"
        style={{ width: "100%" }}
      />
    </Grid>
  </Grid>

  {/* Phone Number and State of Origin Row */}
  <Grid container spacing={2} style={{ marginTop: '10px' }}>
    <Grid item xs={12} sm={6} md={6}>
      <InputField
        name="phoneNumber"
        label="Phone Number"
        value={formData.phoneNumber}
        onChange={handlInputChange}
        placeholder="Enter Phone Number"
        type="tel"
        style={{ width: "100%" }}
      />
    </Grid>
    <Grid item xs={12} sm={6} md={6}>
      <InputField
        name="stateOfOrigin"
        label="State of Origin"
        value={formData.stateOfOrigin}
        onChange={handlInputChange}
        placeholder="Enter State of Origin"
        type="text"
        style={{ width: "100%" }}
      />
    </Grid>
  </Grid>

  {/* Local Govt and Address Row */}
  <Grid container spacing={2} style={{ marginTop: '10px' }}>
   <Grid item xs={12} sm={6} md={6}>
             <Typography
                    variant="body1"
                    sx={{
                      color: "#9b9494",
                      fontSize: "1rem",
                      fontWeight: "bolder",
                      marginTop: "7px",
                    }}
                    mb={1}
                  >
                    LGA
                  </Typography>
  <FormControl fullWidth>

    <InputLabel id="lga-select-label">Local Government Area (LGA)</InputLabel>
    <Select
      labelId="lga-select-label"
      id="lga-select"
      value={formData.localGovernment}
      onChange={handlInputChange}
      label="Local Government Area (LGA)"
      name="localGovernment"
    >
      {Lga.map((lgaItem) => (
        <MenuItem key={lgaItem.lgaId} value={lgaItem.lgaId}>
          {lgaItem.name}
        </MenuItem>
      ))}
    </Select>
  </FormControl>
</Grid>
    <Grid item xs={12} sm={6} md={6}>
      <InputField
        name="address"
        label="Address"
        value={formData.address}
        onChange={handlInputChange}
        placeholder="Enter Full Address"
        type="text"
        style={{ width: "100%" }}
      />
    </Grid>
  </Grid>

  {/* NIN and LASSRA Row */}
  <Grid container spacing={2} style={{ marginTop: '10px' }}>
    <Grid item xs={12} sm={6} md={6}>
      <InputField
        name="nin"
        label="National Identification Number (NIN)"
        value={formData.nin}
        onChange={handlInputChange}
        placeholder="Enter NIN"
        type="text"
        style={{ width: "100%" }}
      />
    </Grid>
    <Grid item xs={12} sm={6} md={6}>
      <InputField
        name="lassra"
        label="LASSRA Number"
        value={formData.lassra}
        onChange={handlInputChange}
        placeholder="Enter LASSRA Number"
        type="text"
        style={{ width: "100%" }}
      />
    </Grid>
  </Grid>
</div>
<div style={{ marginTop: '30px' }}>
  {/* Trade Test Information Section */}
  <Typography variant="h6" gutterBottom>
    TRADE TEST INFORMATION
  </Typography>
  
  {/* Type of Trade Test Row - Single field spanning full width */}
  <Grid container spacing={2}>
    <Grid item xs={12}>
      <InputField
        name="typeOfTradeTest"
        label="Type of Trade Test"
        value={formData.typeOfTradeTest}
        onChange={handlInputChange}
        placeholder="Enter Type of Trade Test"
        type="text"
        style={{ width: "100%" }}
      />
    </Grid>
  </Grid>

  {/* Payment Receipt Number Row - Single field spanning full width */}
  <Grid container spacing={2} style={{ marginTop: '10px' }}>
    <Grid item xs={12}>
      <InputField
        name="paymentReceiptNumber"
        label="Payment Receipt Number"
        value={formData.paymentReceiptNumber}
        onChange={handlInputChange}
        placeholder="Enter Payment Receipt Number"
        type="text"
        style={{ width: "100%" }}
      />
    </Grid>
  </Grid>

  {/* Year of Examination Row - Single field spanning full width */}
  <Grid container spacing={2} style={{ marginTop: '10px' }}>
    <Grid item xs={12}>
      <InputField
        name="yearOfExamination"
        label="Year of Examination"
        value={formData.yearOfExamination}
        onChange={handlInputChange}
        placeholder="Enter Year of Examination"
        type="number"
        inputProps={{ min: "2000", max: "2099" }}
        style={{ width: "100%" }}
      />
    </Grid>
  </Grid>
</div>
<div style={{ marginTop: '30px' }}>
  {/* Professional Information Section */}
  <Typography variant="h6" gutterBottom>
    PROFESSIONAL INFORMATION (FOR CIVIL SERVANTS ONLY)
  </Typography>
  
  {/* Qualification and Qualification Date Row */}
  <Grid container spacing={2}>
    <Grid item xs={12} sm={6} md={6}>
      <InputField
        name="qualification"
        label="Qualification"
        value={formData.qualification}
        onChange={handlInputChange}
        placeholder="Enter Qualification"
        type="text"
        style={{ width: "100%" }}
      />
    </Grid>
    <Grid item xs={12} sm={6} md={6}>
      <InputField
        name="qualificationDate"
        label="Qualification Date"
        type="date"
        value={formData.qualificationDate}
        onChange={handlInputChange}
        InputLabelProps={{ shrink: true }}
        style={{ width: "100%" }}
      />
    </Grid>
  </Grid>

  {/* Date of First Appointment and Present Appointment Row */}
  <Grid container spacing={2} style={{ marginTop: '10px' }}>
    <Grid item xs={12} sm={6} md={6}>
      <InputField
        name="firstAppointmentDate"
        label="Date of First Appointment"
        type="date"
        value={formData.firstAppointmentDate}
        onChange={handlInputChange}
        InputLabelProps={{ shrink: true }}
        style={{ width: "100%" }}
      />
    </Grid>
    <Grid item xs={12} sm={6} md={6}>
      <InputField
        name="presentAppointmentDate"
        label="Date of Present Appointment"
        type="date"
        value={formData.presentAppointmentDate}
        onChange={handlInputChange}
        InputLabelProps={{ shrink: true }}
        style={{ width: "100%" }}
      />
    </Grid>
  </Grid>

  {/* Designation/Grade Level and Oracle Number Row */}
  <Grid container spacing={2} style={{ marginTop: '10px' }}>
    <Grid item xs={12} sm={6} md={6}>
      <InputField
        name="designation"
        label="Designation/Grade Level"
        value={formData.designation}
        onChange={handlInputChange}
        placeholder="Enter Designation/Grade Level"
        type="text"
        style={{ width: "100%" }}
      />
    </Grid>
    <Grid item xs={12} sm={6} md={6}>
      <InputField
        name="oracleNumber"
        label="Oracle Number"
        value={formData.oracleNumber}
        onChange={handlInputChange}
        placeholder="Enter Oracle Number"
        type="text"
        style={{ width: "100%" }}
      />
    </Grid>
  </Grid>

  {/* MDA (Ministry/Department/Agency) Row - Full width */}
  <Grid container spacing={2} style={{ marginTop: '10px' }}>
    <Grid item xs={12}>
      <InputField
        name="mda"
        label="MDA (Ministry/Department/Agency)"
        value={formData.mda}
        onChange={handlInputChange}
        placeholder="Enter MDA"
        type="text"
        style={{ width: "100%" }}
      />
    </Grid>
  </Grid>
</div>
<div style={{ marginTop: '30px' }}>
  {/* Examination Information Section */}
  <Typography variant="h6" gutterBottom>
    EXAMINATION INFORMATION
  </Typography>
  
  {/* Examination Center Row - Full width */}
  <Grid container spacing={2}>
    <Grid item xs={12}>
      <FormControl fullWidth>
        <InputLabel>Examination Center</InputLabel>
        <Select
          name="examinationCenter"
          value={formData.examinationCenter}
          onChange={handlInputChange}
          label="Examination Center"
        >
          <MenuItem value="Lagos">Lagos</MenuItem>
          <MenuItem value="Abuja">Abuja</MenuItem>
          <MenuItem value="Kano">Kano</MenuItem>
          <MenuItem value="Port Harcourt">Port Harcourt</MenuItem>
          <MenuItem value="Enugu">Enugu</MenuItem>
          {/* Add more centers as needed */}
        </Select>
      </FormControl>
    </Grid>
  </Grid>

  {/* Examination Date Row - Full width */}
  <Grid container spacing={2} style={{ marginTop: '10px' }}>
    <Grid item xs={12}>
      <InputField
        name="examinationDate"
        label="Examination Date"
        type="date"
        value={formData.examinationDate}
        onChange={handlInputChange}
        InputLabelProps={{ shrink: true }}
        style={{ width: "100%" }}
      />
    </Grid>
  </Grid>
</div>

        <div
          style={{ display: "flex", flexWrap: "wrap", alignItems: "center" }}
        >
          <Grid container spacing={2}>
            {/* <Grid item xs={6}>
              <InputField
                name="TotalPrice"
                label="Price Per Cancdidate"
                value={modelPrice}
                type="text"
                style={{ width: "100%" }}
              />
            </Grid> */}
            <Grid item xs={2} style={{ paddingTop: "35px" }}>
          <InvoiceButtonWithConfirmation
  invoiceLoading={invoiceLoading}
  handleInvoiceClick={handleInvoiceClick}
/>

            </Grid>
          </Grid>
        </div>
      </div>
    </div>
  );
};

export default IndividualTrade;
